(function($) {
$(document).ready(function(){
   $('#sliderWrapper').addClass('swiper-container').append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
   $('#sliderWrapper > .e-con-inner').addClass('swiper-wrapper');
   $('#sliderWrapper > .e-con-inner > .elementor-element').addClass('swiper-slide');
   setTimeout(() => {
    $('#sliderWrapper > .swiper-wrapper').removeClass('e-con-inner');
    var mySwiper = new Swiper("#sliderWrapper", {
        spaceBetween: 1,
        slidesPerView: 1,
        centeredSlides: true,
        roundLengths: true,
        loop: true,
        initialSlide: 1,
        loopAdditionalSlides: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            1024: {
              slidesPerView: 3,
            },
          },
      });
   }, 500);
});
})(jQuery);